module.exports = __webpack_public_path__ + "img/slide6.af606db0.jpg";